import { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const ListItem = ({ record, columns, onClick, fontStyle }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        boxShadow={theme.shadows[4]}
        onClick={onClick}
        paddingTop="4px"
        paddingBottom="4px"
        paddingLeft="4px"
        paddingRight="4px"
        gap={0.5}
        borderRadius="5px"
        sx={{
          cursor: "pointer",
          bgcolor: "#ffffff",
          "&:hover": { bgcolor: theme.palette.primary.light },
        }}
      >
        {columns.map((column, index) => (
          <Typography
            key={index}
            sx={{
              ...fontStyle,
              fontSize: index === 0 ? fontStyle?.fontSize : "10px",
              color: index === 0 ? "inherit" : theme.palette.text.secondary,
            }}
          >
            {record ? record[column.name] : ""}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default ListItem;
